"use client"
import React from "react"
import Navbar from "../../components/admin/common/Navbar"
import CampaignsList from "../../components/admin/marketing/CampaignsList"

const MarketingCampaigns = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="p-4 md:p-8">
        <CampaignsList />
      </main>
    </div>
  )
}

export default MarketingCampaigns
